import {
  IconNameEnum,
  useFlightStyles,
  useModuleBEM,
} from "@b2bportal/core-themes";
import { CoreFlightsComponent } from "@b2bportal/core-types";
import { isMixedCabin } from "@b2bportal/core-utilities";
import { useI18nContext } from "@hopper-b2b/i18n";
import type { MixedCabinPillProps } from "@tenant/flights";
import { Icon } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./MixedCabinPill.module.scss";

const COMPONENT_KEY = CoreFlightsComponent.MixedCabinPill;

export const MixedCabinPill = ({
  fareSlice,
  className,
}: MixedCabinPillProps) => {
  const styles = useFlightStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { t } = useI18nContext();

  if (!isMixedCabin(fareSlice)) {
    return null;
  }

  return (
    <span className={clsx(block, className)}>
      <Icon iconName={IconNameEnum.info} className={cn("icon")} />
      {t("mixedCabin.title")}
    </span>
  );
};
